import { IBaseCard } from "./base-card.interface";

import type { TaxprepT1Card } from "./taxprep-t1-card";

export interface IFirmTaxprepT1Card extends Omit<TaxprepT1Card, "filePath" | "deliveryMethod"> {
    filePath: string | null;
    documentId: string;
    deliveryMethod: number | null;
}

export function isIFirmTaxprepT1Card(card: IBaseCard): card is IFirmTaxprepT1Card {
    return "documentId" in card && card.documentId !== null && card.documentId !== undefined;
}
